import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import {
  createUnsubscriptionCategory,
  deleteUnsubscriptionCategory,
  fetchAllUnsubscriptionCategory,
  fetchUnsubscriptionListByCategoryId,
  updateUnsubscriptionCategory,
} from '../routines/unsubscribeRoutine';
import { UN_SUBSCRIPTION_ACTIONS } from '../../common/constants/unsubscriptionConstants';

const BULK_EMAIL_MGT_URL = `${envConfig.APIG_URL}email-unsubscribe`;

export function* fetchAllUnsubscribeCategorySaga({ payload }) {
  const active = payload?.active
    ? `?active=${payload.active}&page_size=9999`
    : '?&page_size=9999';

  try {
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/category${active}`
    );
    yield put(fetchAllUnsubscriptionCategory.success(response));
  } catch (error) {
    yield put(fetchAllUnsubscriptionCategory.failure({ error }));
  } finally {
    yield put(fetchAllUnsubscriptionCategory.fulfill());
  }
}
export function* fetchUnsubscriptionsByCategoryIdSaga({ payload }) {
  try {
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/category/${payload.categoryId}`
    );
    yield put(fetchUnsubscriptionListByCategoryId.success(response.data));
  } catch (error) {
    yield put(
      fetchUnsubscriptionListByCategoryId.failure({ error, noAlert: true })
    );
  } finally {
    yield put(fetchUnsubscriptionListByCategoryId.fulfill());
  }
}
export function* createUnsubscriptionCategorySaga({ payload }) {
  try {
    const { formData, callbackFn } = payload;
    const response = yield call(request, `${BULK_EMAIL_MGT_URL}/category`, {
      method: 'POST',
      payload: formData,
    });
    yield put(
      createUnsubscriptionCategory.success({
        response,
        successMessage: SUCCESS_MESSAGES.CREATE_UN_SUBSCRIPTION_CATEGORY,
      })
    );

    if (callbackFn && response?.data?.unsubscriptionCategoryId) {
      callbackFn();
    }
    yield put(fetchAllUnsubscriptionCategory.trigger());
  } catch (error) {
    yield put(createUnsubscriptionCategory.failure({ error }));
  } finally {
    yield put(createUnsubscriptionCategory.fulfill());
  }
}
export function* updateUnsubscriptionCategorySaga({ payload }) {
  try {
    const { formData, categoryId, scope, callbackFn } = payload;
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/category/${categoryId}`,
      {
        method: 'PUT',
        payload: formData,
      }
    );

    if (scope === UN_SUBSCRIPTION_ACTIONS.UPDATE) {
      yield put(
        updateUnsubscriptionCategory.success({
          response,
          successMessage: SUCCESS_MESSAGES.UPDATE_UN_SUBSCRIPTION_CATEGORY,
        })
      );
    }

    if (scope === UN_SUBSCRIPTION_ACTIONS.ACTIVE) {
      yield put(
        updateUnsubscriptionCategory.success({
          response,
          successMessage: SUCCESS_MESSAGES.ACTIVE_UN_SUBSCRIPTION_CATEGORY,
        })
      );
    }

    if (scope === UN_SUBSCRIPTION_ACTIONS.INACTIVE) {
      yield put(
        updateUnsubscriptionCategory.success({
          response,
          successMessage: SUCCESS_MESSAGES.IN_ACTIVE_UN_SUBSCRIPTION_CATEGORY,
        })
      );
    }

    if (callbackFn && response?.data[0]?.unsubscriptionCategoryId) {
      callbackFn();
    }
    yield put(fetchAllUnsubscriptionCategory.trigger());
  } catch (error) {
    yield put(updateUnsubscriptionCategory.failure({ error }));
  } finally {
    yield put(updateUnsubscriptionCategory.fulfill());
  }
}
export function* deleteUnsubscriptionCategorySaga({ payload }) {
  try {
    const { categoryId, callbackFn } = payload;
    const response = yield call(
      request,
      `${BULK_EMAIL_MGT_URL}/category/${categoryId}`,
      {
        method: 'DELETE',
      }
    );
    yield put(
      deleteUnsubscriptionCategory.success({
        response,
        successMessage: SUCCESS_MESSAGES.DELETE_UN_SUBSCRIPTION_CATEGORY,
      })
    );

    if (callbackFn && response?.data?.unsubscriptionCategoryId) {
      callbackFn();
    }

    yield put(fetchAllUnsubscriptionCategory.trigger());
  } catch (error) {
    yield put(deleteUnsubscriptionCategory.failure({ error }));
  } finally {
    yield put(deleteUnsubscriptionCategory.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(
      fetchAllUnsubscriptionCategory.TRIGGER,
      fetchAllUnsubscribeCategorySaga
    ),
    takeLatest(
      fetchUnsubscriptionListByCategoryId.TRIGGER,
      fetchUnsubscriptionsByCategoryIdSaga
    ),
    takeEvery(
      deleteUnsubscriptionCategory.TRIGGER,
      deleteUnsubscriptionCategorySaga
    ),
    takeEvery(
      createUnsubscriptionCategory.TRIGGER,
      createUnsubscriptionCategorySaga
    ),
    takeEvery(
      updateUnsubscriptionCategory.TRIGGER,
      updateUnsubscriptionCategorySaga
    ),
  ]);
}
